var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AsiContentContainer',{attrs:{"columns":3,"columns-lg":4,"columns-xl":5,"with-row-gap":"","small-row-gap":"","small-column-gap":"","no-margin":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }